// src/AuthRoute.tsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authState, userState } from '@recoils/atoms';
import { Box, CircularProgress } from '@mui/material';

function AuthRoute() {
  const auth = useRecoilValue(authState);
  const user = useRecoilValue(userState);
  const location = useLocation();

  // While hydration is not finished, show loading instead of redirect.
  // (Prevents "login flicker" during refresh.)
  if (auth === null) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If auth is true but user is still null, wait a bit (Root is hydrating userState)
  if (auth === true && !user) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (auth === false) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return <Outlet />;
}

export default AuthRoute;
